import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { colorSurfaceActionMeetingIntelligence, colorTextInverseStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SampleBadge, ThumbnailContainer, ThumbnailLoader, Thumbnail, ThumbnailPlaceholder, MeetingTimeBadge } from './styles';
import { WandIcon } from '../../../header';
const contentCss = "c1fw3pmi";
const Content = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(contentCss, props.className)} />);
export const MeetingThumbnail = ({
  isFetching,
  thumbnail,
  duration,
  isSample
}) => <ThumbnailContainer>
    <Content>
      {isSample && <SampleBadge>
          <BodyText color={colorSurfaceActionMeetingIntelligence} size="small" weight="bold">
            {I18n.t('publisher.meeting_intelligence.details.badge.sample_recap')}
          </BodyText>
        </SampleBadge>}
      {isFetching && <ThumbnailLoader />}
      {!isFetching && (thumbnail ? <Thumbnail src={thumbnail} alt="" /> : <ThumbnailPlaceholder>
            <WandIcon />
          </ThumbnailPlaceholder>)}
      <MeetingTimeBadge>
        <BodyText color={colorTextInverseStandard} size="x-small">{duration}</BodyText>
      </MeetingTimeBadge>
    </Content>
  </ThumbnailContainer>;

require("./meeting_thumbnail.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_thumbnail.js");